import { MagicSpellView } from '@Selectors/ninthage/view/MagicSpellView';
import { createSelector } from 'reselect';
import { getMagicPath } from './selector/getMagicPath';
import { Nullable, SpellLvl } from '@Models';

const parseBold = (text: Nullable<string>): Nullable<string> => {
  if (!text) return null;

  return text
    .replace(/\[b\]/gi, '')
    .replace(/\[\/b\]/gi, '')
    .replace(/\[color=#[0-9a-z]+\]/gi, '')
    .replace(/\[\/color\]/gi, '');
};

export const magicPathSpellPresenter = createSelector(
  [getMagicPath],
  (magicPath): MagicSpellView[] => {
    if (!magicPath) return [];

    return magicPath.spells.map(
      (spell) =>
        new MagicSpellView({
          id: spell.id,
          name: spell.name,
          pathName: magicPath.name,
          pathLogo: magicPath.icon ?? '',
          castingValue: parseBold(spell.castingValue),
          typeLvl: SpellLvl[spell.typeLvl],
          targets: [
            parseBold(spell.range),
            ...spell.types.map((i) => i.name),
          ].filter((item): item is string => !!item),
          duration: spell.duration.name,
          effect: parseBold(spell.effect),
        }),
    );
  },
);
